import SiteNav from '@/pages/home/components/SiteNav';
import Hero from '@/pages/home/components/Hero';
import AboutSection from '@/pages/home/components/AboutSection';
import VersionSection from '@/pages/home/components/VersionSection';
import OnlineSection from '@/pages/home/components/OnlineSection';
import DownloadSection from '@/pages/home/components/DownloadSection';
import TipsSection from '@/pages/home/components/TipsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-[#fffbf5] text-stone-800">
      <SiteNav />
      <main>
        <Hero />
        <AboutSection />
        <VersionSection />
        <OnlineSection />
        <DownloadSection />
        <TipsSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}